var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:_vm.cssClasses},[_vm._v("\n  "+_vm._s(_vm.amount)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }